import { render, staticRenderFns } from "./DatesSelector.vue?vue&type=template&id=0efff5eb&scoped=true"
import script from "./DatesSelector.vue?vue&type=script&lang=js"
export * from "./DatesSelector.vue?vue&type=script&lang=js"
import style0 from "./DatesSelector.vue?vue&type=style&index=0&id=0efff5eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efff5eb",
  null
  
)

export default component.exports